import React from 'react';
import { Star } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export const Testimonials = () => {
  const {
    t
  } = useLanguage();
  return <section className="py-8 md:py-16 bg-white" data-id="element-296">
      <div className="container mx-auto px-3 md:px-8" data-id="element-297">
        <div className="bg-blue-800 text-white py-2 md:py-3 px-4 md:px-6 rounded-t-lg inline-block mb-4 md:mb-8" data-id="element-298">
          <h2 className="text-base md:text-xl font-bold" data-id="element-299">
            {t('testimonials.header')}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-300">
          {[{
          name: 'Donna R.',
          text: t('testimonials.testimonial1')
        }, {
          name: 'Martin S.',
          text: t('testimonials.testimonial2')
        }, {
          name: 'Mariana T.',
          text: t('testimonials.testimonial3')
        }].map((testimonial, index) => <div key={index} className="bg-blue-50 p-4 md:p-6 rounded-lg shadow-md" data-id="element-301">
              <div className="flex mb-3 md:mb-4" data-id="element-302">
                {[...Array(5)].map((_, i) => <Star key={i} className="text-yellow-500" size={18} fill="#EAB308" data-id="element-303" />)}
              </div>
              <p className="text-sm md:text-base text-gray-700 mb-3 md:mb-4 italic" data-id="element-304">
                "{testimonial.text}"
              </p>
              <p className="text-sm md:text-base font-semibold text-gray-800" data-id="element-305">
                {testimonial.name}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};